import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 20,
};

export const studentsListTableControllerSlice = createSlice({
    name: 'studentsListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const { changeCurrentPage } = studentsListTableControllerSlice.actions;

export default studentsListTableControllerSlice.reducer;